import useRequestSearch from "./useRequestSearch";

interface RequestSearchInitializerProps {
	namespace: string;
	serverSidePaging?: boolean;
	showResultsOnInitialPageLoad?: boolean;
}

export const RequestSearchInitializer = ({
	namespace,
	serverSidePaging = false,
	showResultsOnInitialPageLoad = false,
}: RequestSearchInitializerProps) => {
	useRequestSearch(namespace, serverSidePaging, showResultsOnInitialPageLoad);

	return null;
};
